import {Alert} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAlert, useAuth} from "../../context";

export function OurAlert({variant, show, msg, title, children}) {
    const [showInt, setShowInt] = useState(false)

    useEffect(() => {
        setShowInt(!!show)
    }, [show]);

    return <Alert variant={variant} dismissible show={showInt} onClose={() => setShowInt(false)}>
        {title && <Alert.Heading>{title}</Alert.Heading>}
        {msg}{children}
    </Alert>
}

export function OurClearAlert({variant, msg, onClear, title}) {

    return <Alert variant={variant} dismissible show={msg != null} onClose={onClear}>
        {title && <Alert.Heading>{title}</Alert.Heading>}
        {msg}
    </Alert>
}

export function AdminUserAlert() {
    const {uid} = useParams()
    const {userId} = useAuth()

    const [showInt, setShowInt] = useState(false)

    useEffect(() => {
        setShowInt(userId !== uid)
    }, [uid]);

    const to = `/backend/user/${uid}`

    return <Alert variant="info" dismissible show={showInt} onClose={() => setShowInt(false)}>
        Watch out, you are managing user ID: <Alert.Link as={Link} to={to}>{uid}</Alert.Link>.
    </Alert>
}
